import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MonedasComponent} from '../monedas.component'
import {CurrencyService} from '../../../../../core/services/parameters/currency.service';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';

@Component({
  selector: 'conversion-modal',
  templateUrl: './conversion.html',
  styleUrls: ['./conversion.component.scss']
})
export class ConversionModal implements OnInit {

  conversionForm: FormGroup;
  loading = false;
  durationInSeconds: 3;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(
    public dialogRef: MatDialogRef<MonedasComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private _snackBar: MatSnackBar,
    private currencyService: CurrencyService) {
  }

  ngOnInit(): void {
    this.conversionForm = this.fb.group({
      country: [this.data.row.country, Validators.required],
      currency: [this.data.row.currency, Validators.required],
      symbol: [this.data.row.symbol, Validators.required],
      conversion: [, Validators.required],
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  get f() {
    return this.conversionForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.conversionForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    if (form.valid) {
      this.loading = false;
    } else {
      this.loading = false;
    }
  }

  addTRMHandbook(form) {
    const data = {
      currencyId: this.data.row.id,
      currencyValue: form.value.conversion,
    }
    if (form.value.conversion != null)
      this.currencyService.setConversionHandbook(data).subscribe(res => {
        if (res === 1) {
          this.openSnackBar('Ya existe una TRM para el día de hoy', 'alert', 'succes-snackbar');
        } else if (res === -1) {
          this.openSnackBar('Error interno del sistema', 'alert', 'succes-snackbar');
        } else {
          this.openSnackBar('Creado correctamente', 'alert', 'succes-snackbar');
        }
        this.dialogRef.close();
      });
  }

  openSnackBar(message: string, action: string, type: string) {
    this._snackBar.open(message, action, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      panelClass: [type]
    });
  }
}
